import React, { FunctionComponent, memo, ReactNode, useMemo } from 'react'

import { ThemeProvider as Emotion } from '@emotion/react'
import { mergeDeepRight } from 'ramda'

interface CreateLayoutOpts {
  displayName?: string
}

export const createLayout = (
  layoutTheme: Record<string, any>,
  { displayName = 'Layout' }: CreateLayoutOpts = {},
) => {
  const Layout: FunctionComponent<{
    children: ReactNode
    theme?: Record<string, any>
  }> = memo(({ theme, ...props }) => {
    // TODO: maybe we can use something lightweight then ramda here?!
    const computedTheme = useMemo(
      () => (theme ? mergeDeepRight(layoutTheme, theme) : layoutTheme),
      [theme],
    )

    return <Emotion {...props} {...{ theme: computedTheme }} />
  })

  Layout.displayName = displayName
  return Layout
}

// export const ThemeProvider = createLayout({})
